<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            @if (data.mode !== FormMode.Creation) {
                <div class="form-item">
                    <mat-form-field class="mat-form-field-name">
                        <mat-label>Id</mat-label>
                        <input matInput [formControl]="idFormControl" [(ngModel)]="data.record.id" autocomplete="off" />
                    </mat-form-field>
                </div>
            }
            <div class="form-item">
                <mat-form-field class="mat-form-field-action-type">
                    <mat-label>Article</mat-label>
                    <mat-select [formControl]="articleFormControl" [(ngModel)]="data.record.articleId" required>
                        @for (article of articles; track article) {
                            <mat-option [value]="article.id">{{ article.code }} - {{ article.designation1 }}</mat-option>
                        }
                    </mat-select>
                    @if (articleFormControl?.errors?.required && (articleFormControl?.dirty || articleFormControl.touched)) {
                        <mat-error>Le champ 'Article' est obligatoire.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field class="mat-form-field-name">
                    <mat-label>Alias</mat-label>
                    <input matInput [formControl]="aliasFormControl" [(ngModel)]="data.record.alias" autocomplete="off" required />
                    @if (aliasFormControl?.errors?.required && (aliasFormControl?.dirty || aliasFormControl.touched)) {
                        <mat-error>Le champ 'Alias' est obligatoire.</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" [ngClass]="{ hidden: data.mode === FormMode.Reading }" (click)="cancel()">Annuler</button>
        @if (data.mode !== FormMode.Reading) {
            <button mat-raised-button class="accent-button" [mat-dialog-close]="data.record" [disabled]="!isValid">Enregistrer</button>
        } @else {
            <button mat-raised-button class="accent-button" (click)="cancel()">Ok</button>
        }
    </mat-card-actions>
</mat-card>
